import { api } from '@/lib/api/client';

/** One immutable version of Simon's editable guidance (sreg-api agent_prompt). */
export interface PromptVersion {
  id: string;
  agentName: string;
  type: 'instruction';
  version: number;
  versionName?: string;
  note?: string;
  content: string;
  /** Most document searches Simon may run for one answer; unset = default (4). */
  maxSearches?: number;
  active: boolean;
  createdAt: string;
  createdBy: string;
}

const Q = { agentName: 'simon', type: 'instruction' };

export function listVersions(signal?: AbortSignal): Promise<PromptVersion[]> {
  return api.get<PromptVersion[]>('/agent-prompts', Q, signal);
}

/** Saving creates a new version and makes it the active one. */
export const DEFAULT_MAX_SEARCHES = 4;
export const MAX_SEARCHES_RANGE = { min: 1, max: 10 } as const;

export function saveVersion(body: {
  content: string;
  versionName?: string;
  note?: string;
  maxSearches?: number;
}): Promise<PromptVersion> {
  return api.post<PromptVersion>('/agent-prompts', { ...body, agentName: 'simon' });
}

/** Activate any version — this is the rollback. */
export function activateVersion(id: string): Promise<PromptVersion> {
  return api.post<PromptVersion>(`/agent-prompts/${id}/activate`);
}
